var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 28V25.3333C29.3334 22.8482 27.6337 20.7601 25.3334 20.168M20.6667 4.38768C22.6212 5.17886 24 7.09508 24 9.33333C24 11.5716 22.6212 13.4878 20.6667 14.279M22.6667 28C22.6667 25.515 22.6667 24.2725 22.2607 23.2924C21.7194 21.9855 20.6811 20.9473 19.3743 20.406C18.3942 20 17.1517 20 14.6667 20H10.6667C8.18167 20 6.93915 20 5.95904 20.406C4.65223 20.9473 3.61396 21.9855 3.07266 23.2924C2.66669 24.2725 2.66669 25.515 2.66669 28M18 9.33333C18 12.2789 15.6122 14.6667 12.6667 14.6667C9.72117 14.6667 7.33335 12.2789 7.33335 9.33333C7.33335 6.38781 9.72117 4 12.6667 4C15.6122 4 18 6.38781 18 9.33333Z",
    stroke: "#14B8A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers01);
export default __webpack_public_path__ + "static/media/users-01.2e7266496156a0d1315d9d101e6e0474.svg";
export { ForwardRef as ReactComponent };